// UX-009: one place that builds the "add documents" link so every Upload button
// inside a project carries the project (and folder) the user is already in.
export function uploadLinkFor(projectId?: string | null, folderId?: string | null): string {
  if (!projectId) return '/upload'
  const q = new URLSearchParams({ project: projectId })
  if (folderId) q.set('folder', folderId)
  return `/upload?${q.toString()}`
}
